import {GitMergeQueueIcon} from '@primer/octicons-react'
import {MergeQueueEntry} from '@github-ui/mergebox/components/sections/merge-queue/MergeQueueEntry'

import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {useMergeabilityData} from '../mergeability/use-mergeability-data'
import {noop} from '@github-ui/noop'

export function shouldShowQueuedPR(data: ReturnType<typeof useMergeabilityData>) {
  return data?.mergeQueueSection?.shouldRender ?? false
}

export function QueuedPR({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()

  if (!data) return null

  const {mergeBoxPullRequest} = data

  return (
    <MergeQueueEntry
      mergeQueue={mergeBoxPullRequest.mergeQueue}
      mergeQueueEntry={mergeBoxPullRequest.mergeQueueEntry}
      viewerCanAddAndRemoveFromMergeQueue={mergeBoxPullRequest.viewerCanAddAndRemoveFromMergeQueue}
      onDequeueSuccess={noop} // TODO - figure out where focus should go after dequeue
      analyticsTargetPrefix="OVERVIEW"
    >
      <ForYouItem
        leadingVisual={<ForYouLeadingIcon icon={GitMergeQueueIcon} variant="warning" emphasized hideBackground />}
        emphasizedLeadingVisual
        title={<MergeQueueEntry.Title />}
        ariaLabel="Queued"
        itemName="queued-pr"
        variant={variant}
        description={<MergeQueueEntry.Description />}
        actionSlot={<MergeQueueEntry.DequeueAction buttonProps={{size: 'small'}} />}
      />
    </MergeQueueEntry>
  )
}
